<template>
  <div class="flex items-start gap-12">
    <Avatar :name="senderName" :imageUrl="senderAvatarUrl" size="base" class="mt-4" />
    <div class="max-w-full flex flex-col items-start">
      <p class="text-s text-grey-text-subdued mb-4">{{ senderName }}</p>
      <Card :customClasses="bubbleClasses" :ariaLabel="ariaLabel">
        <MessageBubbleBody :body="body" :bodyHtml="bodyHtml" />
      </Card>
      <MessageBubbleTimestamp :timestamp="timestamp" />
    </div>
  </div>
</template>

<script lang="ts">
import Card from '@/components/card/Card.vue';
import Avatar from '@/components/avatar/Avatar.vue';
import MessageBubbleBody from './MessageBubbleBody.vue';
import MessageBubbleTimestamp from './MessageBubbleTimestamp.vue';

const INCOMING_BUBBLE_CLASSES = 'bg-grey-background-contrast w-full px-12 py-10';

export default {
  name: 'MessageBubbleIncoming',
  components: {
    Card,
    Avatar,
    MessageBubbleBody,
    MessageBubbleTimestamp,
  },
  props: {
    body: {
      type: String,
      default: '',
    },
    bodyHtml: {
      type: String,
      default: '',
    },
    senderName: {
      type: String,
      required: true,
    },
    senderAvatarUrl: {
      type: String,
      default: '',
    },
    timestamp: {
      type: String,
      default: '',
    },
    ariaLabel: {
      type: String,
      required: true,
    },
  },
  computed: {
    bubbleClasses(): string {
      return INCOMING_BUBBLE_CLASSES;
    },
  },
};
</script>
